<template >
  <jet-dialog-modal :show="is_show" maxWidth="3xl" @close="closePopUp" aria-labelledby="modal-title">
    <div class="sr-only" aria-live="polite">{{ accessibilityAnnouncement }}</div>
    <template #title>
      <div class="text-lg">
        <div class="flex justify-between items-center">
          <h2 id="modal-title" class="sm:pt-4 pt-2 lg:text-2xl sm:text-lg text-sm"> {{ date }} </h2><jet-secondary-button aria-label="Close"
            class="cursor-pointer pt-4" @click="closePopUp">X</jet-secondary-button>
        </div>

      </div>
    </template>

    <template #content>
      <div class="w-full">
        <div v-for="(product, indexs) in sortArrays(products)" class="sm:flex " v-show="product.isShowOnModal">
          <div class="sm:w-2/5 bg-[#3f3f3f] relative w-full">
            <img v-if="product.photo_store_path"
              :src="$page.props.storage_image_url + product.photo_store_path + '_resize'"
              :original="$page.props.storage_image_url + product.photo_store_path" @error="$helpers.replaceByDefault"
              class="w-full h-[125px] object-cover" :alt="'Image for ' + getOptionName(product)">
            <img v-else :src="$page.props.asset_url + '/images/pizza-icon-image.jpg'"
              class="w-full h-[125px] object-cover" :alt="'Image for ' + getOptionName(product)">


            <div v-if="$page.props.is_login" class="absolute top-[84px] right-3">
              <button @click="showPhotoChangePopUp(product)" aria-haspopup="dialog" aria-label="Change photo"
                class="text-black bg-white rounded-full w-8 h-8 flex justify-center items-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" data-slot="icon" class="w-6 h-6">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z" />
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z" />
                </svg>
              </button>
            </div>

            <div v-if="product.recipes && product.recipes.length > 0">
              <div v-for="(group, gIndex) in groupRecipesByCategory(product.recipes)" :key="gIndex" role="group" :aria-labelledby="'cat-' + indexs + '-' + gIndex">
                <b :id="'cat-' + indexs + '-' + gIndex" class="text-[#ffc919] text-sm leading-3 uppercase px-3 block mt-2">{{ group.category }}</b>
                <ul class="w-full h-auto px-3 pt-1 pb-2 space-y-1">
                  <li v-for="recipe in group.recipes" :key="recipe.id"
                    class="text-[#fff] text-base leading-6 capitalize mb-2 xl:text-lg">
                    <button @click="recipeIndex = recipe.originalIndex" :class="recipe.originalIndex === recipeIndex ? 'text-[#0094cc]' : ''"
                      class="trim_text underline text-left w-full focus:ring-2 focus:ring-[#0094cc] outline-none"
                      :aria-pressed="recipe.originalIndex === recipeIndex">
                      {{ recipe.show_name }} <span
                        class="bg-white text-[#3f3f3f] p-[3px] rounded-md ml-1 sm:text-lg font-bold text-base"
                        v-if="recipe?.allergens_name && recipe?.allergens_name != ''"
                        aria-label="Contains Allergens">A</span></button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <CalendarPopupSingle :product="product" :recipeIndex="recipeIndex" :userLoginCheck="userLoginCheck" />
        </div>

      </div>
    </template>

    <template #footer>

      <nav aria-label="Day selection" class="block p-2.5">
        <ul class="flex items-center -space-x-px text-sm justify-center">
          <li>
            <a href="javascript:void(0);" @click="goToPreviousSlider(products.length)"
              class="flex items-center justify-center px-3  ml-0 leading-tight text-[#385591] text-base"
              aria-label="Previous Option">
              <span class="sr-only">Previous</span>
              <svg class="w-2.5 h-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 6 10">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M5 1 1 5l4 4" />
              </svg>
            </a>
          </li>

          <li v-for="(product, pageindex) in sortArrays(products)">
            <!-- Calculate the shouldShow result once -->

            <template v-if="shouldShowPage(pageindex) === true || shouldShowPage(pageindex) != 'betweenpage'">
              <a @click="changeSlider(product, products.length)" href="javascript:void(0);"
                class="flex items-center justify-center px-3 h-7 w-7 leading-tight  hover:bg-[#0094cc]  rounded-full mr-1 hover:text-white"
                :class="product.isShowOnModal === true ? 'bg-[#0094cc] text-white' : 'text-black'"
                :aria-label="'Go to ' + getOptionName(product)">
                {{ shouldShowPage(pageindex) === 'betweenpage' ? '..' : pageindex + 1 }}
              </a>
            </template>
          </li>

          <li>
            <a href="javascript:void(0);" @click="goToNextSlider(products.length)"
              class="flex items-center justify-center px-3  ml-0 leading-tight text-black "
              aria-label="Next Option">
              <span class="sr-only">Next</span>
              <svg class="w-2.5 h-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 6 10">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="m1 9 4-4-4-4" />
              </svg>
            </a>
          </li>
        </ul>
      </nav>
    </template>
  </jet-dialog-modal>

  <ChangePhotoOnFront ref="ChangePhotoOnFront" :products="products" :userLoginCheck="userLoginCheck"
    @closeCalendarPopUp="closePopUp" />
</template>
<script>
import vClickOutside from "click-outside-vue3";
var moment = require('moment');
import JetDialogModal from "@/Jetstream/DialogModal";

import CalendarPopupSingle from "@/Pages/ParentPortal/Home/CalendarPopupSingle";

import ChangePhotoOnFront from "@/Pages/ParentPortal/Home/ChangePhotoOnFront";

export default {
  directives: {
    ClickOutside: vClickOutside,
  },
  props: ['products', 'date', 'userLoginCheck'],
  components: {
    vClickOutside,
    JetDialogModal,
    ChangePhotoOnFront,
    CalendarPopupSingle
  },

  data() {
    return {
      is_show: false,
      optionImage: "",
      recipeIndex: -1,
      accessibilityAnnouncement: ""
    }
  },

  methods: {

    sortedRecipeArray(recipe_arrays) {
      console.log("recipe_arrays", recipe_arrays);
      let a = _.orderBy(recipe_arrays, 'name', 'asc');
      a = _.orderBy(a, 'category_sort', 'asc');
      console.log("recipe_arrays a", recipe_arrays);
      return a;
    },

    groupRecipesByCategory(recipes) {
      const sorted = this.sortedRecipeArray(recipes);
      const groups = [];
      let currentGroup = null;
      sorted.forEach((recipe, index) => {
        if (!currentGroup || currentGroup.category !== recipe.category) {
          currentGroup = { category: recipe.category, recipes: [] };
          groups.push(currentGroup);
        }
        recipe.originalIndex = index;
        currentGroup.recipes.push(recipe);
      });
      return groups;
    },

    closePopUp() {
      this.is_show = false;
    },
    showPopUp(index, rindex) {
      console.log("showPopUp", index);
      this.is_show = true;
      // this.changeSlider(this.prodcuts[index], this.prodcuts.length);
      this.products.forEach((product, i) => {
        if (i == index) {
          this.products[i]['isShowOnModal'] = true;
        } else {
          this.products[i]['isShowOnModal'] = false;
        }
      });
      this.recipeIndex = rindex;
      this.accessibilityAnnouncement = `Opened details for ${this.date}. Showing ${this.getOptionName(this.products[index])}`;
    },

    showPhotoChangePopUp(product) {
      this.$refs.ChangePhotoOnFront.showPhotoChangePopUp(product);
    },

    loadCalendar() {
      this.$emit('loadCalendar');
    },

    loadExcludedDateData() {
      this.$emit('loadExcludedDateData');
    },


    sortArrays(arrays) {
      return _.orderBy(arrays, 'sort_order', 'asc');
    },
    getOptionName(mc) {
      if (mc.name == '') {
        return "Option " + mc.sort_order;
      } else {
        return mc.name;
      }
    },
    changeSlider(mc, productLength) {

      this.recipeIndex = -1;

      this.products.forEach(product => {
        product['isShowOnModal'] = false;
      });

      mc['isShowOnModal'] = true;
      this.accessibilityAnnouncement = `Showing ${this.getOptionName(mc)}`;
    },

    // goToPreviousSlider(productLength) {
    //   this.recipeIndex = -1;
    //   alert('1');
    //   // if (this.products.length === productLength) {
    //   const currentIndex = this.products.findIndex(product => product.isShowOnModal);
    //   const prevIndex = (currentIndex - 1);
    //   console.log('currentIndex', currentIndex);

    //   if (currentIndex > 0) {
    //     this.products[currentIndex].isShowOnModal = false;
    //     this.products[prevIndex].isShowOnModal = true;
    //   }
    //   // }
    // },

    sortArrays(arrays) {
      return _.orderBy(arrays, 'sort_order', 'asc');
    },



    shouldShowPage(pageindex) {

      if (this.products.length > 1) {

        const totalLength = this.products.length;
        const currentIndex = this.products.findIndex(product => product.isShowOnModal);

        if (pageindex >= currentIndex - 2 && pageindex <= currentIndex + 2) {
          return true;
        }

        if (pageindex == this.products.length - 1) {
          return true;
        }

      }
      console.log('paginationdata', pageindex);
    },
    goToNextSlider(productLength) {

      this.recipeIndex = -1;

      // console.log("recipeIndex", this.recipeIndex);
      // if (this.products.length === productLength) {
      const currentIndex = this.products.findIndex(product => product.isShowOnModal);
      const nextIndex = (currentIndex + 1);
      if (currentIndex < productLength - 1) {
        this.products[currentIndex].isShowOnModal = false;
        this.products[nextIndex].isShowOnModal = true;
        this.accessibilityAnnouncement = `Showing ${this.getOptionName(this.products[nextIndex])}`;
        console.log(currentIndex, nextIndex);
      }
    },

    goToPreviousSlider(productLength) {

      this.recipeIndex = -1;
      // console.log("recipeIndex", this.recipeIndex);
      if (productLength === 'greater') {
        if (this.products.length > 4) {
          const currentIndex = this.products.findIndex(product => product.isShowOnModal);
          const prevIndex = (currentIndex - 1);
          if (currentIndex > 0) {
            this.products[currentIndex].isShowOnModal = false;
            this.products[prevIndex].isShowOnModal = true;
            this.accessibilityAnnouncement = `Showing ${this.getOptionName(this.products[prevIndex])}`;
            console.log(currentIndex, prevIndex);
          }
        }
      }

      if (this.products.length === productLength) {
        const currentIndex = this.products.findIndex(product => product.isShowOnModal);
        const prevIndex = (currentIndex - 1);
        console.log('currentIndex', currentIndex);

        if (currentIndex > 0) {

          this.products[currentIndex].isShowOnModal = false;
          this.products[prevIndex].isShowOnModal = true;
          this.accessibilityAnnouncement = `Showing ${this.getOptionName(this.products[prevIndex])}`;
        }
      }
    }
  },
  watch: {
    recipeIndex(newVal) {
      if (newVal !== -1) {
        const product = this.products.find(p => p.isShowOnModal);
        if (product && product.recipes) {
          const recipes = this.sortedRecipeArray(product.recipes);
          const recipe = recipes[newVal];
          if (recipe) {
            this.accessibilityAnnouncement = `Now showing nutritional information for ${recipe.show_name}`;
          }
        }
      } else {
        const product = this.products.find(p => p.isShowOnModal);
        if (product) {
          this.accessibilityAnnouncement = `Now showing nutritional information for ${this.getOptionName(product)}`;
        }
      }
    }
  }
}
</script>

<style scoped>
.box-hover .bg-white.popup-shadow {
  font-size: 12px;
  width: 460px;
}

.bg-white.popup-shadow {
  padding: 0px;
}

.box-hover .bg-white.popup-shadow li.text-black {
  padding: 3px 8px;
  margin-bottom: 5px;
}

/* .button-none{
    bottom: -100%;
    z-index: 10;
    } */

/* .box-hover{
    overflow: hidden;
    } */
/* .box-hover:hover .button-none{
    bottom: 0;
    } */

.bottom-0-space {
  bottom: 6px;
}
</style>

<style scoped>
.box-hover .bg-white.popup-shadow {
  font-size: 12px;
  width: 460px;
}

.bg-white.popup-shadow {
  padding: 0px;
}

.box-hover .bg-white.popup-shadow li.text-black {
  padding: 3px 8px;
  margin-bottom: 5px;
}

/* .button-none{
bottom: -100%;
z-index: 10;
} */

/* .box-hover{
overflow: hidden;
} */
/* .box-hover:hover .button-none{
bottom: 0;
} */

.bottom-0-space {
  bottom: 6px;
}
</style>

<style>
.font-24 {
  font-size: 24px;
}

.color-24 {
  color: #636363;
}

.p-color {
  color: #969696;
}

.p-size {
  font-size: 15px;
}

.online-color {
  color: #22af4b;
}

.offline-color {
  color: #cb0000;
}

.number-background-color {
  background-color: #cb0000;
}

.online-background-color {
  background-color: #22af4b;
}

.week-cycle-color {
  color: #1c2a47;
}

.week-cycle-fontsize {
  font-size: 14px;
}

.three-dot-color {
  color: #38558e;
}

.table-background {
  background-color: #f3f3f3;
}

.last-td-background {
  background-color: white !important;
  opacity: 0.7;
}

.td-width {
  width: 14.28%;
  min-height: 135px;
  min-width: 170px;
}

.td-width .absolute-div {
  left: 35px;
}

.cart-color {
  color: #f7a53a;
}

.plus-font-size {
  font-size: 20px;
}

.menu-day-background {
  background-color: #cbcbcb;
}

.box-sizing {
  width: 100px;
  min-height: 60px;
}

.popup-shadow {
  box-shadow: 0px 5px 10px #0000005e;
}

.w-52 {
  width: 185px;
  width: 185px;
  max-height: 161px;
  overflow: auto;
  overflow-x: hidden;
}

.w-3 {
  width: 60px;
  height: 60px;
}

.hover_font_size {
  font-size: 13px;
  font-weight: bold;
  text-decoration: underline;
}

.title_color {
  color: #f7a53a;
}

.popup-shadow {
  box-shadow: 0px 5px 10px #0000005e;
}

.show-box {
  display: block !important;
}

.hide-box {
  display: none !important;
}

/* .box-type-show:hover .show-box {
    display: block;
} */

.absolute-div {
  position: absolute;
  top: 0px;
  left: 50px;
}

.add_food_color {
  background-color: #38558e;
}

.absolute-items {
  position: absolute;
  top: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;
  margin: auto;
}

.absolute-items2 {

  position: absolute;
  right: 8px;
  bottom: 8px;
  margin: auto;
}

.text-color-circle-icon {
  color: #38558e;
}

.mh-135 {
  height: 215px;
  padding: 4px;
}

.mh-135>div {
  padding: 4px;
}

.mh-135>div img {
  object-fit: cover;
}

span.option_title {
  line-height: 17px;
  padding-bottom: 10px;
}
</style>
